/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { fileType } from 'types';
import Dropdown from 'components/Dropdown';
import DropdownItem from 'components/DropdownItem';

import './style.scss';

export default class DropDownMenu extends Component {
  static propTypes = {
    createNewTempFile: PropTypes.func.isRequired,
    createNewTempFolder: PropTypes.func.isRequired,
    deleteAll: PropTypes.func.isRequired,
    exportAll: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(fileType),
  };

  handleCreateNewTempFile = () => {
    this.props.createNewTempFile();
    this.dropdown.hide();
  };

  handleCreateNewTempFolder = () => {
    this.props.createNewTempFolder();
    this.dropdown.hide();
  };

  handleExportAll = () => {
    this.props.exportAll();
    this.dropdown.hide();
  };

  handleDeleteAll = () => {
    this.props.deleteAll(this.props.items);
    this.dropdown.hide();
  };

  render() {
    return (
      <Dropdown
        data-test="dropdown-content"
        inputRef={el => {
          this.dropdown = el;
        }}
        styleName="dropdown"
        trigger={
          <span
            data-tip
            className="icon-options"
            data-event="mouseover"
            data-for="upload-appconfig-files"
            data-test="icon-options"
            styleName="trigger"
          />
        }
      >
        <DropdownItem
          className="item"
          data-test="create-file"
          onClick={this.handleCreateNewTempFile}
        >
          Create File
        </DropdownItem>

        <DropdownItem
          className="item"
          data-test="create-folder"
          onClick={this.handleCreateNewTempFolder}
        >
          Create Folder
        </DropdownItem>

        {this.props.items.length > 0 && (
          <React.Fragment>
            <DropdownItem
              className="item"
              data-test="export"
              onClick={this.handleExportAll}
            >
              Export all
            </DropdownItem>
            <hr />
            <DropdownItem
              className="item"
              data-test="delete"
              onClick={this.handleDeleteAll}
            >
              Delete All
            </DropdownItem>
          </React.Fragment>
        )}
      </Dropdown>
    );
  }
}
